import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header, Alert } from 'components';
import { Popover, Typography, Grid } from '@mui/material';

import RanReportRFForm from './components/RanReportRFForm';
import RanReportRFClusterForm from './components/RanReportRFClusterForm';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(1)
	},
}));

const ReportRFExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	return (
		<Page className={classes.root} title="Acceptance">
			<Header module="Acceptance" view="Report RF" />
			<br />
			<Grid container spacing={3}>
				<Grid item md={12} xs={12}>
					<Alert
						variant="info"
						message="Site Report"
						aria-owns={open ? 'mouse-over-popover-site' : undefined}
						aria-haspopup="true"
						onMouseOver={handlePopoverOpen}
						onMouseLeave={handlePopoverClose}
					/>
					<RanReportRFForm />
				</Grid>
				<Grid item md={12} xs={12}>
					<Alert
						variant="info"
						message="Cluster Report"
						aria-owns={open ? 'mouse-over-popover-cluster' : undefined}
						aria-haspopup="true"
						onMouseOver={handlePopoverOpen}
						onMouseLeave={handlePopoverClose}
					/>
					<RanReportRFClusterForm />
				</Grid>
			</Grid>
			<Popover
				id="mouse-over-popover-site"
				className={classes.popover}
				classes={{
					paper: classes.paper,
				}}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
			>
				<Typography sx={{ p: 2 }}>When run for multiple sites, it will generate multiple site level reports.</Typography>
			</Popover>
			<Popover
				id="mouse-over-popover-cluster"
				className={classes.popover}
				classes={{
					paper: classes.paper,
				}}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
			>
				<Typography sx={{ p: 2 }}>When run for multiple sites, it will generate one cluster level report.</Typography>
			</Popover>
		</Page>
	);
};

export default ReportRFExport;
